<template>
  <div id="app">
    <!-- <Navbar /> -->
    <Home />
  </div>
</template>

<script>
// import Navbar from './components/layout/Navbar'
import Vue from 'vue'
import Home from './components/Home'

// import styles from './assets/style.scss'
// import materialize from 'materialize-css/sass/materialize.scss'

Vue.filter('formatPrice', (p) => {
  return typeof p !== 'number' ? p : p.toFixed(2).replace('.', ',').replace(',00','')
})

export default {
  name: 'app',
  components: {
    // Navbar,
    Home
  }
}
</script>

<style lang="scss">
@import "assets/sass/style";


</style>
